import { initializeApp, getApps, getApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Fill these in from your Firebase project settings, or (recommended)
// set them as REACT_APP_FIREBASE_* values in a .env.local file so real
// keys never get committed. See .env.example.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// True only once real values exist. Until then we deliberately skip
// initializeApp/getAuth entirely - calling those with an empty apiKey
// throws immediately and (since the support widget is mounted globally)
// was taking down the whole page with a blank screen.
export const firebaseReady = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

let app = null;
let db = null;
let auth = null;

if (firebaseReady) {
  app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  // initializeFirestore (rather than plain getFirestore) with long-polling
  // auto-detect: some networks/browsers/extensions silently break the
  // default WebSocket-style streaming connection Firestore normally uses
  // for live updates - the symptom is exactly "works after a refresh,
  // but new messages don't arrive on their own." Auto-detect falls back
  // to long-polling transparently when that happens, without forcing it
  // (and therefore paying its overhead) on connections where it's not needed.
  db = initializeFirestore(app, { experimentalAutoDetectLongPolling: true });
  auth = getAuth(app);
} else if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.warn(
    '[firebase] Missing REACT_APP_FIREBASE_* env vars. Copy .env.example to ' +
      '.env.local, fill in your Firebase project config, and restart `npm start`. ' +
      'The support widget stays inactive until then instead of crashing the page.'
  );
}

export { db, auth };
export default app;